import { Component, OnInit, Input, Renderer2, ElementRef } from '@angular/core';
@Component({
  selector: 'app-inspection-category',
  templateUrl: './inspection-category.component.html',
  styleUrls: ['./inspection-category.component.scss'],
})
export class InspectionCategoryComponent implements OnInit {
  @Input() isFinalized: boolean;
  @Input() isArchived: boolean;
  @Input() category: any = {};
  @Input() workStatus: string = '';

  isExpanded: boolean = true;
  screenWidth: number = 0;
  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit() {
    this.getScreenSize();
    this.renderer.listen(window, 'resize', () => {
      this.getScreenSize();
    });
  }

  toggleIsExpanded() {
    this.isExpanded = !this.isExpanded;
  }

  getScreenSize() {
    this.screenWidth = window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
  }

  showStatusCheck() {
    return `<span class="dotted-green ml-2 mr-1 mt-1"></span>
    <span class="font-12 font-gray-55">Good</span>

    <span class="dotted-yellow ml-2 mr-1 mt-1"></span>
    <span class="font-12 font-gray-55">Average</span>

    <span class="dotted-red ml-2 mr-1 mt-1"></span>
    <span class="font-12 font-gray-55">Poor</span>`
  }

}
